import React, {Component} from 'react';
import {Link, withRouter} from "react-router-dom";

import {Button, Form, Header, Icon, List, Message, Table} from "semantic-ui-react";

import {
    confirmEmail,
    displayValidationErrors,
    initSignUpForm,
    signUp,
    updateDanceSchool,
    updateEmail,
    updateFirstName,
    updateLastName,
    updatePassword,
    updatePasswordConfirmation,
    updatePhoneNumber,
    updateTerms
} from "../../actions/signUp";
import TextField from "../common/TextField";
import {connect} from "react-redux";

class SignUp extends Component {

    componentDidMount() {
        if (this.props.match.params.token) {
            this.props.dispatch(confirmEmail(this.props.match.params.token));
        } else {
            this.props.dispatch(initSignUpForm());
        }
    }

    onChangeEmail(e) {
        this.props.dispatch(updateEmail(e.target.value));
    }

    onChangePassword(e) {
        this.props.dispatch(updatePassword(e.target.value));
    }

    onChangePasswordConfirmation(e) {
        this.props.dispatch(updatePasswordConfirmation(this.props.password, e.target.value));
    }

    onChangeFirstName(e) {
        this.props.dispatch(updateFirstName(e.target.value));
    }

    onChangeLastName(e) {
        this.props.dispatch(updateLastName(e.target.value));
    }

    onChangePhoneNumber(e) {
        this.props.dispatch(updatePhoneNumber(e.target.value));
    }

    onChangeDanceSchool(e) {
        this.props.dispatch(updateDanceSchool(e.target.value));
    }

    onChangeTerms(e) {
        this.props.dispatch(updateTerms(!this.props.terms));
    }

    onClickSignUp() {
        if (this.props.emailErrors.length > 0
            || this.props.passwordErrors.length > 0
            || this.props.passwordConfirmationErrors.length > 0
            || this.props.firstNameErrors.length > 0
            || this.props.lastNameErrors.length > 0
            || this.props.phoneNumberErrors.length > 0
            || this.props.danceSchoolErrors.length > 0
            || this.props.termsErrors.length > 0) {
            this.props.dispatch(displayValidationErrors());
        } else {
            this.props.dispatch(signUp(
                this.props.email,
                this.props.password,
                this.props.firstName,
                this.props.lastName,
                this.props.phoneNumber,
                this.props.danceSchool
            ));
        }
    }

    render() {
        const showRegistrationForm = !this.props.match.params.token && !this.props.signingCompleted;
        const showRegistrationCompletedMessage = !this.props.match.params.token && this.props.signingCompleted;
        const showConfirmationEmailMessage = this.props.match.params.token;
        return (
            <div style={{margin: "1rem auto", maxWidth: "768px"}}>
                {showConfirmationEmailMessage &&
                <Message
                    positive={this.props.confirmingEmailCompleted}
                    negative={this.props.confirmingEmailFailed}
                    icon>
                    {this.props.confirmingEmail && <Icon name='circle notched' loading/>}
                    {this.props.confirmingEmailCompleted && <Icon name="check circle"/>}
                    {this.props.confirmingEmailFailed && <Icon name="exclamation triangle"/>}
                    {this.props.confirmingEmail && <Message.Content style={{textAlign: "left"}}>
                        Trwa aktywacja konta
                    </Message.Content>}
                    {this.props.confirmingEmailCompleted &&
                    <Message.Content style={{textAlign: "left"}}>
                        Twoje konto zostało aktywowane. <Link to="/logowanie">Zaloguj się!</Link>
                    </Message.Content>}
                    {this.props.confirmingEmailFailed && <Message.Content style={{textAlign: "left"}}>
                        Aktywacja nie powiodła się. Skontaktuj się z administratorem aby uzyskać więcej
                        informacji.
                    </Message.Content>}
                </Message>}
                {showRegistrationCompletedMessage &&
                <Message positive icon>
                    <Icon name="mail"/>
                    <Message.Content style={{textAlign: "left"}}>
                        Twoje konto zostało utworzone, ale nie jest jeszcze aktywne.
                        W ciągu 5 minut na podany adres e-mail zostanie wysłany link aktywacyjny.
                        Użyj go aby aktywować konto swoje konto.
                    </Message.Content>
                </Message>}
                {showRegistrationForm && <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={2}>
                                <Header>
                                    <Icon name="edit"/>
                                    <Header.Content>Rejestracja</Header.Content>
                                </Header>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell width={6}>
                                <TextField
                                    noMargin
                                    icon="mail"
                                    iconPosition="left"
                                    placeholder="E-mail"
                                    disabled={this.props.signing || this.props.signingCompleted}
                                    value={this.props.email}
                                    showErrors={this.props.formErrorsVisible}
                                    errors={this.props.emailErrors}
                                    onChange={(e) => {
                                        this.onChangeEmail(e)
                                    }}/>
                            </Table.Cell>
                            <Table.Cell width={6}>
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>
                                <TextField
                                    noMargin
                                    type="password"
                                    icon="key"
                                    iconPosition="left"
                                    placeholder="Hasło"
                                    disabled={this.props.signing || this.props.signingCompleted}
                                    value={this.props.password}
                                    showErrors={this.props.formErrorsVisible}
                                    errors={this.props.passwordErrors}
                                    onChange={(e) => {
                                        this.onChangePassword(e)
                                    }}/>
                            </Table.Cell>
                            <Table.Cell>
                                <TextField
                                    noMargin
                                    type="password"
                                    icon="key"
                                    iconPosition="left"
                                    placeholder="Potwierdzenie hasła"
                                    disabled={this.props.signing || this.props.signingCompleted}
                                    value={this.props.passwordConfirmation}
                                    showErrors={this.props.formErrorsVisible}
                                    errors={this.props.passwordConfirmationErrors}
                                    onChange={(e) => {
                                        this.onChangePasswordConfirmation(e)
                                    }}/>
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>
                                <TextField
                                    noMargin
                                    placeholder="Imię"
                                    disabled={this.props.signing || this.props.signingCompleted}
                                    value={this.props.firstName}
                                    showErrors={this.props.formErrorsVisible}
                                    errors={this.props.firstNameErrors}
                                    onChange={(e) => {
                                        this.onChangeFirstName(e)
                                    }}/>
                            </Table.Cell>
                            <Table.Cell>
                                <TextField
                                    noMargin
                                    placeholder="Nazwisko"
                                    disabled={this.props.signing || this.props.signingCompleted}
                                    value={this.props.lastName}
                                    showErrors={this.props.formErrorsVisible}
                                    errors={this.props.lastNameErrors}
                                    onChange={(e) => {
                                        this.onChangeLastName(e)
                                    }}/>
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell verticalAlign="top">
                                <TextField
                                    noMargin
                                    placeholder="Numer telefonu"
                                    disabled={this.props.signing || this.props.signingCompleted}
                                    value={this.props.phoneNumber}
                                    showErrors={this.props.formErrorsVisible}
                                    errors={this.props.phoneNumberErrors}
                                    onChange={(e) => {
                                        this.onChangePhoneNumber(e)
                                    }}/>
                            </Table.Cell>
                            <Table.Cell verticalAlign="top">
                                <TextField
                                    noMargin
                                    placeholder="Organizacja / Szkoła tańca"
                                    disabled={this.props.signing || this.props.signingCompleted}
                                    value={this.props.danceSchool}
                                    showErrors={this.props.formErrorsVisible}
                                    errors={this.props.danceSchoolErrors}
                                    onChange={(e) => {
                                        this.onChangeDanceSchool(e)
                                    }}/>
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell colSpan={2}>
                                <Form.Checkbox style={{textAlign: 'justify'}}
                                               label='Wyrażam zgodę na gromadzenie, przetwarzanie i wykorzystywanie przez właściciela serwisu skrutiner.pl moich danych oraz danych tancerzy wpisanych przeze mnie do systemu, teraz i w przyszłości, zgodnie z polskim prawem, w szczególności ustawą o ochronie danych osobowych. Zgodnie z tą ustawą, podanie tych danych jest dobrowolne, a ponadto każdemu przysługuje prawo wglądu do swoich danych oraz ich poprawiania lub usunięcia.
                                               Jednocześnie oświadczam, że posiadam wszelkie niezbędne zgody od swoich tancerzy, a w przypadku tancerzy niepełnoletnich od ich rodziców lub opiekunów prawnych, pozwalające na przetwarzanie i wykorzystywanie ich danych osobowych tancerzy w celu zapewnienia poprawnej rejestracji zgłoszenia oraz organizacji turniejów.'
                                               checked={this.props.terms}
                                               disabled={this.props.signing || this.props.signingCompleted}
                                               onChange={(e) => {
                                                   this.onChangeTerms(e)
                                               }}/>
                                {this.props.formErrorsVisible &&
                                <List style={{color: "#9f3a38", textAlign: "left"}}>
                                    {this.props.termsErrors.map((error, index) => <List.Item
                                        key={index}>{error}</List.Item>)}
                                </List>}
                            </Table.Cell>
                        </Table.Row>
                        {this.props.signingFailed && <Table.Row>
                            <Table.Cell colSpan={2} textAlign="center">
                                <Message negative icon>
                                    <Icon name="exclamation triangle"/>
                                    <Message.Content style={{textAlign: "left"}}>
                                        Rejestracja nie powiodła się. Skontaktuj się z administratorem aby
                                        uzyskać więcej informacji.
                                    </Message.Content>
                                </Message>
                            </Table.Cell>
                        </Table.Row>}
                        <Table.Row>
                            <Table.Cell colSpan={2} textAlign="center">
                                <Button
                                    primary
                                    disabled={this.props.signing || this.props.signingCompleted}
                                    loading={this.props.signing}
                                    onClick={(e) => {
                                        this.onClickSignUp(e)
                                    }}>Zarejestruj się</Button>
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row><Table.Cell colSpan={2} textAlign="center">
                            <p>
                                Masz juz konto? {this.props.signing
                                ? <span>Zaloguj się!</span>
                                : <Link to="/logowanie">Zaloguj się!</Link>}
                            </p>
                        </Table.Cell></Table.Row>
                    </Table.Body>
                </Table>}
            </div>
        );
    }
};

function mapStateToProps(state) {
    return {
        authenticated: state.session.authenticated,
        email: state.signUp.email,
        emailErrors: state.signUp.emailErrors,
        password: state.signUp.password,
        passwordErrors: state.signUp.passwordErrors,
        passwordConfirmation: state.signUp.passwordConfirmation,
        passwordConfirmationErrors: state.signUp.passwordConfirmationErrors,
        firstName: state.signUp.firstName,
        firstNameErrors: state.signUp.firstNameErrors,
        lastName: state.signUp.lastName,
        lastNameErrors: state.signUp.lastNameErrors,
        phoneNumber: state.signUp.phoneNumber,
        phoneNumberErrors: state.signUp.phoneNumberErrors,
        danceSchool: state.signUp.danceSchool,
        danceSchoolErrors: state.signUp.danceSchoolErrors,
        terms: state.signUp.terms,
        termsErrors: state.signUp.termsErrors,
        signing: state.signUp.signing,
        signingFailed: state.signUp.signingFailed,
        signingError: state.signUp.signingError,
        signingCompleted: state.signUp.signingCompleted,
        formErrorsVisible: state.signUp.formErrorsVisible,
        confirmingEmail: state.signUp.confirmingEmail,
        confirmingEmailFailed: state.signUp.confirmingEmailFailed,
        confirmingEmailError: state.signUp.confirmingEmailError,
        confirmingEmailCompleted: state.signUp.confirmingEmailCompleted
    }
}

export default withRouter(connect(mapStateToProps)(SignUp))



// WEBPACK FOOTER //
// ./src/components/routes/SignUp.js